"use strict";

var _interopRequireDefault = require("/mnt/www/planning-web-v2/node_modules/@babel/runtime/helpers/interopRequireDefault.js");

require("core-js/modules/es6.reflect.construct");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.number.constructor");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.array.find");

require("core-js/modules/web.dom.iterable");

var _toConsumableArray2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));

var _defineProperty2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));

require("core-js/modules/es6.function.name");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));

var _classCallCheck2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/createClass.js"));

var _inherits2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/inherits.js"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js"));

var _getPrototypeOf2 = _interopRequireDefault(require("/mnt/www/planning-web-v2/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js"));

var _tslib = require("tslib");

var _vuePropertyDecorator = require("vue-property-decorator");

var _vuexClass = require("vuex-class");

var _socket = require("socket.io-client");

var _elementUi = require("element-ui");

var _loading = require("@/mixins/loading/loading");

var _lastMileDeliveryWellcome = require("@/mixins/last-mile-delivery-wellcome/last-mile-delivery-wellcome");

var _permission = require("@/mixins/permission/permission");

var _idle = require("@/mixins/idle/idle");

var _orderDateRange = _interopRequireDefault(require("../components/order-date-range/order-date-range.vue"));

var _orderFilter = _interopRequireDefault(require("../components/order-filter/order-filter.vue"));

var _orderFilterTag = _interopRequireDefault(require("../components/order-filter-tag/order-filter-tag.vue"));

var _orderTable = _interopRequireDefault(require("../components/order-table/order-table.vue"));

var _ganttFilter = _interopRequireDefault(require("../components/gantt-filter/gantt-filter.vue"));

var _ganttPagination = _interopRequireDefault(require("../components/gantt-pagination/gantt-pagination.vue"));

var _ganttChart = _interopRequireDefault(require("../components/gantt-chart/gantt-chart.vue"));

var _planHeader = _interopRequireDefault(require("../components/plan-header/plan-header.vue"));

var _planSearch = _interopRequireDefault(require("../components/plan-search/plan-search.vue"));

var _orderSummary = _interopRequireDefault(require("../components/order-summary/order-summary.vue"));

var _truckSummary = _interopRequireDefault(require("../components/truck-summary/truck-summary.vue"));

var _variables = _interopRequireDefault(require("@/styles/mixins/_variables.scss"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var LMDManualAssignComponent = /*#__PURE__*/function (_Mixins) {
  (0, _inherits2.default)(LMDManualAssignComponent, _Mixins);

  var _super = _createSuper(LMDManualAssignComponent);

  function LMDManualAssignComponent() {
    var _this;

    (0, _classCallCheck2.default)(this, LMDManualAssignComponent);
    _this = _super.apply(this, arguments);
    _this.isShowFailedOrders = false;
    _this.failedOrders = [];
    _this.isEnableAllTrucks = true;
    _this.selectedPlanId = null;
    _this.initAutoAddedDays = 0;
    _this.timeStepper = 30;
    _this.currentPlanId = null;
    _this.truckCurrentPage = 1;
    _this.truckPageSize = 10;
    _this.socket = null;
    _this.isBlocked = false;
    _this.autoAssignUsername = null;
    _this.globalUsers = [];
    _this.isFilterTruck = false;
    _this.isShowEnabledTruck = false;
    _this.isUpdateBufferTrucks = {
      hasValue: false
    };
    return _this;
  }

  (0, _createClass2.default)(LMDManualAssignComponent, [{
    key: "$isOrderFullscreen",
    get: function get() {
      return this.$store.getters['common/isOrderFullscreen'];
    }
  }, {
    key: "planHeaderStyle",
    get: function get() {
      return {
        top: !this.$isFullscreen ? '60px' : 0
      };
    }
  }, {
    key: "planBodyStyle",
    get: function get() {
      var height = '47px';

      if (this.$isFullscreen && !this.$isOrderFullscreen) {
        height = '44px';
      }

      if (this.$isFullscreen && this.$isOrderFullscreen) {
        height = '0';
      }

      return {
        'margin-top': height
      };
    }
  }, {
    key: "beforeRouteLeave",
    value: function beforeRouteLeave(to, from, next) {
      this.confirmUnsavedChanges(to, from, next);
    }
  }, {
    key: "created",
    value: function created() {
      if (window.innerWidth < _variables.default['md-min']) {
        this.$isMobile = true;
      }
    }
  }, {
    key: "mounted",
    value: function () {
      var _mounted = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _query;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.routes = [];
                _context.next = 3;
                return this.$getUnassignedOrders();

              case 3:
                _context.next = 5;
                return this.$getTrucks();

              case 5:
                _context.next = 7;
                return this.$initPlan();

              case 7:
                this.socket = (0, _socket.io)("".concat(process.env.VUE_APP_API_ROUTING_SOCKET, "/v1/lastmile/planning"), {
                  secure: true,
                  reconnection: true,
                  rejectUnauthorized: false,
                  query: (_query = {}, (0, _defineProperty2.default)(_query, process.env.VUE_APP_CUSTOMER_KEY, this.$userInformation.customerKey), (0, _defineProperty2.default)(_query, "routeName", this.$route.name), (0, _defineProperty2.default)(_query, "userEmail", this.$userInformation.user.name), _query),
                  extraHeaders: (0, _defineProperty2.default)({}, process.env.VUE_APP_SECRET_KEY, process.env.VUE_APP_SECRET_KEY_HASH)
                });
                this.updateSelectedData();

              case 9:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function mounted() {
        return _mounted.apply(this, arguments);
      }

      return mounted;
    }()
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.routes = [];

      if (this.socket) {
        this.socket.close();
      }
    }
  }, {
    key: "handleManualAssign",
    value: function () {
      var _handleManualAssign = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(planId) {
        var truckObj;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                truckObj = this.getTruckInPlan(this.$selectedTruck);

                if (truckObj) {
                  _context2.next = 6;
                  break;
                }

                _context2.next = 4;
                return this.manualAssignTruck('INIT', null, planId);

              case 4:
                _context2.next = 8;
                break;

              case 6:
                _context2.next = 8;
                return this.manualAssignTruck('UPDATE', truckObj, planId);

              case 8:
                _context2.next = 10;
                return this.savePlan(this.$plan);

              case 10:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function handleManualAssign(_x) {
        return _handleManualAssign.apply(this, arguments);
      }

      return handleManualAssign;
    }()
  }, {
    key: "manualAssignTruck",
    value: function () {
      var _manualAssignTruck = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(type, truckObj, planId) {
        var _this2 = this;

        var bufferSelectedOrders, isNewPlanId, newPlanId, res, prefix, newPlanIds, hasCompletedWaypoint, hasLocked, hasAssignComplete, isAssignDriver, payload, isAssignSuccessful, assignDriverResponse, invalidOrders, message;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                this.isManualAssignLoading = true;
                bufferSelectedOrders = (0, _toConsumableArray2.default)(this.$selectedOrders);
                isNewPlanId = planId === 'newPlanId';
                newPlanId = planId;
                res = null;

                if (!isNewPlanId) {
                  _context3.next = 11;
                  break;
                }

                prefix = this.helper.generateNewPlanId(this.$userData.planIdFormat, this.$planDate, this.$userInformation, 'lastmile');
                _context3.next = 9;
                return this.routeAPI.generateLoadPlanId(prefix, 1);

              case 9:
                newPlanIds = _context3.sent;
                newPlanId = this.helper.get(newPlanIds, 'data.0', []);

              case 11:
                hasCompletedWaypoint = false;
                this.helper.forEach(this.$selectedOrders, function (order) {
                  if (_this2.helper.some(order['waypoints'], function (i) {
                    return i['completedTime'] !== '0000-00-00 00:00:00' && i['completedTime'] !== null;
                  })) {
                    hasCompletedWaypoint = true;
                    return false;
                  }
                });

                if (!(type === 'INIT')) {
                  _context3.next = 17;
                  break;
                }

                _context3.next = 16;
                return this.handleNewTruckObj({
                  planId: newPlanId
                });

              case 16:
                res = _context3.sent;

              case 17:
                hasLocked = false;
                hasAssignComplete = false;

                if (!(type === 'UPDATE')) {
                  _context3.next = 30;
                  break;
                }

                if (truckObj['routes'] && truckObj['routes'].length >= 1) {
                  hasLocked = !!truckObj['routes'].find(function (tData) {
                    return tData['locked'] === true;
                  });
                  hasAssignComplete = truckObj['routes'].find(function (tData) {
                    return tData['status'].toUpperCase() === 'ASSIGNED' || tData['status'].toUpperCase() === 'INTRANSIT' || tData['status'].toUpperCase() === 'COMPLETED';
                  });
                }

                if (!((hasLocked || hasAssignComplete || hasCompletedWaypoint) && !isNewPlanId)) {
                  _context3.next = 27;
                  break;
                }

                _context3.next = 24;
                return this.handleAdhocV2ExistingTruckObj({
                  planId: newPlanId,
                  truckObj: truckObj,
                  unassignedOrders: this.$selectedOrders
                });

              case 24:
                res = _context3.sent;
                _context3.next = 30;
                break;

              case 27:
                _context3.next = 29;
                return this.handleExistingTruckObj({
                  planId: newPlanId,
                  isNewPlanId: isNewPlanId,
                  truckObj: truckObj
                });

              case 29:
                res = _context3.sent;

              case 30:
                if (!this.helper.isUndefined(res)) {
                  _context3.next = 33;
                  break;
                }

                this.isManualAssignLoading = false;
                return _context3.abrupt("return");

              case 33:
                this.handleFailedOrders(res);
                isAssignDriver = this.helper.get(res, 'isAssignDriver', false);
                payload = this.helper.get(res, 'assignDriverPayload', []);
                isAssignSuccessful = false;

                if (!(isAssignDriver && payload.length)) {
                  _context3.next = 55;
                  break;
                }

                _context3.next = 40;
                return this.assignDriver(payload);

              case 40:
                assignDriverResponse = _context3.sent;
                isAssignSuccessful = assignDriverResponse['isSuccess'];
                invalidOrders = assignDriverResponse['invalidOrders'];
                message = {
                  title: this.$i18n.t('planning.messages.assignOrderSuccess'),
                  duration: 5000
                };

                if (!isAssignSuccessful) {
                  _context3.next = 51;
                  break;
                }

                _elementUi.Notification.success(message);

                this.$isAssignedDriverChanges = false;
                _context3.next = 49;
                return this.savePlan(this.$plan);

              case 49:
                _context3.next = 53;
                break;

              case 51:
                message['message'] = "".concat(this.$i18n.t('planning.messages.assigningFailedBecause'), " ").concat(invalidOrders, " ").concat(this.$i18n.t('planning.messages.cantBeAssigned'));

                _elementUi.Notification.error(message);

              case 53:
                _context3.next = 56;
                break;

              case 55:
                this.$anyChanges = true;

              case 56:
                // Insert log

                /*this.insertLogs('manual assign', {
                    routeType: 'last-mile-delivery',
                    planDate: this.$planDate,
                     truckId: this.$selectedTruck,
                    truck: this.getTruckInfo(this.$selectedTruck),
                    planId: newPlanId,
                    planDetails: {
                        isInit: type === 'INIT',
                        hasCompletedWaypoint,
                        hasLocked,
                        hasAssignComplete,
                        hasFailedOrders: res['isShowFailedOrders'],
                        isAssignDriver,
                        isAssignSuccessful,
                    },
                    orders: bufferSelectedOrders
                        ? bufferSelectedOrders.map((oData) => ({
                                shipmentReference: oData['shipmentReference'] || '',
                                orderId: oData['id'] || '',
                          }))
                        : [],
                     user: this.$userInformation.user,
                    globalUsers: this.$GLOBAL_ACTIVE_USERS,
                });*/
                this.isManualAssignLoading = false;

              case 57:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function manualAssignTruck(_x2, _x3, _x4) {
        return _manualAssignTruck.apply(this, arguments);
      }

      return manualAssignTruck;
    }()
  }, {
    key: "handleEnableAllTrucks",
    value: function handleEnableAllTrucks() {
      this.isEnableAllTrucks = true;
    }
  }, {
    key: "handleDisableAllTrucks",
    value: function handleDisableAllTrucks() {
      this.isEnableAllTrucks = false;
    }
  }, {
    key: "handleSearchValueIsFound",
    value: function handleSearchValueIsFound(newVal) {
      this.selectedPlanId = newVal;
    }
  }, {
    key: "recalculateTimeList",
    value: function recalculateTimeList(newVal) {
      this.initAutoAddedDays = newVal;
    }
  }, {
    key: "handleTimeStepperChanges",
    value: function handleTimeStepperChanges(newVal) {
      this.timeStepper = newVal;
    }
  }, {
    key: "handleFailedOrders",
    value: function handleFailedOrders(_ref) {
      var isShowFailedOrders = _ref.isShowFailedOrders,
          failedOrders = _ref.failedOrders;
      this.isShowFailedOrders = isShowFailedOrders;
      this.failedOrders = this.helper.orderBy(failedOrders.map(function (fOData) {
        fOData['finalCode'] = fOData['code'] || '';
        fOData['finalPriority'] = '';

        if (fOData['code']) {
          var codeArr = fOData['code'].toString().split('-');

          if (codeArr.length === 2) {
            fOData['finalPriority'] = codeArr[0] || '';
            fOData['finalCode'] = codeArr[1] || '';
          }
        }

        return fOData;
      }), ['finalPriority'], ['asc']);
      this.$failedOrders = failedOrders;
    }
  }, {
    key: "handleCurrentPlanIdChanges",
    value: function handleCurrentPlanIdChanges(newVal) {
      this.currentPlanId = newVal;
    }
  }, {
    key: "updateSelectedData",
    value: function updateSelectedData() {
      var _this3 = this;

      this.socket.on('connect', /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _this3.logger.info('socket-connected', _this3.socket.id);

                _this3.$socketId = _this3.socket.id;
                _this3.isBlocked = false;
                _this3.isOccupied = false;

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      })));
      this.socket.on('connected', /*#__PURE__*/function () {
        var _ref3 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(res) {
          var userData;
          return regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) {
              switch (_context5.prev = _context5.next) {
                case 0:
                  userData = _this3.helper.get(res, 'data.userData', []);

                  if (userData && userData.length >= 1) {
                    userData = userData.filter(function (uData) {
                      return Number(uData.companyId) === Number(_this3.$userInformation.company.id);
                    });

                    if (userData[0] && userData[0]['routeName'] !== _this3.$route.name && userData[0]['userId'] !== _this3.$socketId) {
                      _this3.isBlocked = true;
                      _this3.autoAssignUsername = userData[0]['userName'].split('@')[0];
                      _this3.isOccupied = true;
                      _this3.occupyingUsername = userData[0]['userName'].split('@')[0];
                      _this3.occupyingRoute = userData[0]['routeName'];
                    } else {
                      _this3.isBlocked = false;
                      _this3.isOccupied = false;
                    }
                  } else {
                    _this3.isBlocked = false;
                    _this3.isOccupied = false;
                  }

                  _this3.logger.info('Socket - Connected', res);

                  if (res.data && res.status === 'success') {
                    _this3.$GLOBAL_ACTIVE_USERS = (0, _toConsumableArray2.default)(userData);
                    _this3.$GLOBAL_SELECTED_ORDERS = res.data.orderData.length >= 1 ? res.data.orderData.filter(function (oData) {
                      return oData['userId'] !== _this3.$socketId;
                    }) : [];
                    _this3.$GLOBAL_SELECTED_TRUCKS = res.data.truckData.length >= 1 ? res.data.truckData.filter(function (tData) {
                      return tData['userId'] !== _this3.$socketId;
                    }) : [];
                  }

                case 4:
                case "end":
                  return _context5.stop();
              }
            }
          }, _callee5);
        }));

        return function (_x5) {
          return _ref3.apply(this, arguments);
        };
      }());
      this.socket.on('saved', function (res) {
        _this3.logger.info('Socket - Saved', res);

        if (res.status === 'success' && res.data && res.data.code === _this3.$planDate) {
          _this3.updatePlanFromSocket(res.data);
        }
      });
      this.socket.on('error', /*#__PURE__*/function () {
        var _ref4 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(res) {
          return regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) {
              switch (_context6.prev = _context6.next) {
                case 0:
                  _this3.logger.info('socket-error');

                case 1:
                case "end":
                  return _context6.stop();
              }
            }
          }, _callee6);
        }));

        return function (_x6) {
          return _ref4.apply(this, arguments);
        };
      }());
      this.socket.on('connect_error', /*#__PURE__*/function () {
        var _ref5 = (0, _asyncToGenerator2.default)( /*#__PURE__*/regeneratorRuntime.mark(function _callee7(res) {
          return regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) {
              switch (_context7.prev = _context7.next) {
                case 0:
                  _this3.logger.info('socket-connect_error');

                case 1:
                case "end":
                  return _context7.stop();
              }
            }
          }, _callee7);
        }));

        return function (_x7) {
          return _ref5.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "getReasonFailMessage",
    value: function getReasonFailMessage(reason) {
      return this.$t("planning.autoAssignInvalidCodes.".concat(reason));
    }
  }, {
    key: "getReasonFailParam",
    value: function getReasonFailParam() {
      var reason = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var reasonArr = reason.split('~');
      return this.helper.get(reasonArr, '1', '-').trim();
    }
  }, {
    key: "handleTruckSizeChange",
    value: function handleTruckSizeChange(newVal) {
      this.truckPageSize = newVal;
    }
  }, {
    key: "handleTruckCurrentChange",
    value: function handleTruckCurrentChange(newVal) {
      this.truckCurrentPage = newVal;
    }
  }, {
    key: "handleIsFilterTruckChanges",
    value: function handleIsFilterTruckChanges(newVal) {
      this.isFilterTruck = newVal;
    }
  }, {
    key: "handleIsShowEnabledTruckChanges",
    value: function handleIsShowEnabledTruckChanges(newVal) {
      this.isShowEnabledTruck = newVal;
    }
  }, {
    key: "handleUpdateBufferTrucks",
    value: function handleUpdateBufferTrucks(newVal) {
      this.isUpdateBufferTrucks = newVal;
    }
  }]);
  return LMDManualAssignComponent;
}((0, _vuePropertyDecorator.Mixins)(_permission.PermissionMixin, _loading.LoadingMixin, _lastMileDeliveryWellcome.LastMileDeliveryMixin, _idle.IdleMixin));

(0, _tslib.__decorate)([(0, _vuexClass.Getter)('isFullscreen', {
  namespace: 'common'
})], LMDManualAssignComponent.prototype, "$isFullscreen", void 0);
LMDManualAssignComponent = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  name: 'LMDManualAssignComponent',
  components: {
    'order-date-range': _orderDateRange.default,
    'order-filter': _orderFilter.default,
    'order-filter-tag': _orderFilterTag.default,
    'order-table': _orderTable.default,
    'gantt-filter': _ganttFilter.default,
    'gantt-pagination': _ganttPagination.default,
    'gantt-chart': _ganttChart.default,
    'plan-header': _planHeader.default,
    'plan-search': _planSearch.default,
    'order-summary': _orderSummary.default,
    'truck-summary': _truckSummary.default,
    'el-row': _elementUi.Row,
    'el-col': _elementUi.Col,
    'el-dialog': _elementUi.Dialog
  }
})], LMDManualAssignComponent);
var _default = LMDManualAssignComponent;
exports.default = _default;